export default function CheckboxField({
  label,
  required,
  options,
  formData,
  index,
  onChange,
}) {
  return (
    <div className="mb-6 gap-16">
      <label className="block text-sm font-medium mb-3 text-gray-900">
        {label} {required && <span className="text-red-500">*</span>}
      </label>

      {options.map((option) => {
        const currentAnswer = formData[index].answer || [];
        const isSelected = currentAnswer.some((ans) =>
          typeof ans === "object"
            ? ans.index === option.index
            : ans === option.value
        );

        return (
          <div className="flex items-center gap-2 mb-4" key={option.index}>
            <input
              name={`field-${index}`}
              type="checkbox"
              value={option.value}
              checked={isSelected}
              onChange={(e) => {
                const checkedValues = formData[index].answer || [];
                const updatedValues = e.target.checked
                  ? [
                      ...checkedValues,
                      { index: option.index, value: option.value },
                    ]
                  : checkedValues.filter((v) =>
                      typeof v === "object"
                        ? v.index !== option.index
                        : v !== option.value
                    );
                onChange(index, "answer", updatedValues);
              }}
              className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
            />

            <label
              htmlFor={`field-${index}`}
              className="leading-none text-sm font-medium text-gray-900"
            >
              {option.value}
            </label>

            {/* Inline Note Input */}
            {formData[index].hasNotes && isSelected && (
              <input
                type="text"
                value={option.notes || ""}
                onChange={(e) =>
                  onChange(index, "notes", e.target.value, option.index)
                }
                placeholder="enter your notes here"
                className="ml-2 flex-1 px-3 py-2 bg-gray-50 rounded-lg border border-gray-300 text-sm text-gray-900"
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
